import {EventType} from "./event-type";

export class Event {

  public id: string;
  public eventType: EventType;

  constructor(id: string, eventType: EventType) {
    this.id = id;
    this.eventType = eventType;
  }

}
